import axios from './axios-instance'

export default {
  async getContext(contextType, contextId) {
    return axios.get('ai/context', {
      params: {
        context_type: contextType,
        context_id: contextId,
      },
    })
  },

  async askAi(contextType, contextId, prompt, chatId) {
    return axios.post('ai/chat', {
      context_type: contextType,
      context_id: contextId,
      prompt,
      ai_thread_uuid: chatId,
    })
  },

  async archiveThread(uuid) {
    return axios.delete(`ai/chat/${uuid}`)
  },

  async rateMessage(uuid, rating) {
    return axios.post(`ai/messages/${uuid}/rate`, {
      rating,
    })
  },

  async generateJobMetadata(jobId, title, description) {
    return axios.post('ai/generate-job-metadata', {
      job_id: jobId,
      title,
      description,
    })
  },

  async generateRateGuidance(payload) {
    return axios.post('ai/generate-rate-guidance', payload)
  },

  async recapConversations() {
    return axios.post('ai/recap-conversations')
  },

  async askConversations(question, aiThreadUuid) {
    return axios.post('ai/ask-conversations', {
      question,
      ai_thread_uuid: aiThreadUuid,
    })
  },
}
